import styled, { css } from 'styled-components';
import { colors, layout } from '@prisjakt/ui-base';

type UserAvatarProps = {
  size: number;
  hasAvatar: boolean;
  isLoggedIn: boolean;
};

export const UserAvatar = styled.div<UserAvatarProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; /* Some characters in Open Sans look weird here */
  font-weight: 500;
  font-size: ${p => Math.round(0.67 * p.size)}px;
  text-transform: uppercase;
  height: ${p => p.size}px;
  width: ${p => p.size}px;
  border-radius: ${p => p.size}px;
  color: ${p => p.theme.icons.tertiary};
  transition: all ${layout.animations.buttonTransition};

  img {
    transition: all ${layout.animations.buttonTransition};
    border-radius: ${p => p.size}px;

    &:hover {
      filter: brightness(80%);
    }
  }

  &:hover,
  /* UserAvatar isn't interactive itself, so we need to style its
    interactive state based on whether it's inside a focused element */
  .focus-visible & {
    cursor: pointer;
    color: ${colors.lightBlue3};
  }

  ${p =>
    p.isLoggedIn &&
    !p.hasAvatar &&
    css`
      background: ${colors.lightBlue1};
      color: ${colors.white};

      &:hover,
      .focus-visible & {
        color: ${colors.white};
        background: ${colors.lightBlue3};
      }
    `};
`;
